import { createBrowserClient } from '@supabase/ssr'
import { supabaseAuthCookieName } from '@/shared/lib/devSlot'

export function createClient() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL
  const key = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

  if (!url || !key) {
    throw new Error(
      'Missing Supabase credentials. Please set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY in your .env.local file.'
    )
  }

  // In per-worktree dev isolation, give each slot its own auth cookie name so
  // concurrent localhost previews don't clobber each other's session (see
  // devSlot.ts). Undefined elsewhere → the library default name is unchanged.
  const cookieName = supabaseAuthCookieName()

  return createBrowserClient(
    url,
    key,
    cookieName ? { cookieOptions: { name: cookieName } } : undefined
  )
}
